import { useState } from "react"
import Link from "next/link"
import styles from "../styles/Signup.module.css"
import { getAuth, sendSignInLinkToEmail } from "firebase/auth"

import firebase from "../firebase/clientApp"

// TODO bring this back inline to simplify state handling
const EmailInput = ({ disabled, successHandler }) => {
  const [email, setEmail] = useState("")

  let url = "https://weight-graph.com/signupComplete"
  if (
    typeof window !== "undefined" &&
    window.location.host === "localhost:3000"
  ) {
    url = "http://localhost:3000/signupComplete"
  }

  const actionCodeSettings = {
    url: url,
    handleCodeInApp: true,
  }

  const changeEmail = (event) => {
    setEmail(event.target.value)
  }

  const submit = (event) => {
    event.preventDefault()

    const auth = getAuth(firebase)
    sendSignInLinkToEmail(auth, email, actionCodeSettings)
      .then(() => {
        console.log("success!")
        // The link was successfully sent. Inform the user.
        // Save the email locally so you don't need to ask the user for it again
        // if they open the link on the same device.
        window.localStorage.setItem("emailForSignIn", email)
        successHandler()
        // ...
      })
      .catch((error) => {
        const errorCode = error.code
        const errorMessage = error.message
        // ...
      })
  }

  return (
    <form onSubmit={submit} className="py-4">
      <label>
        Email:{" "}
        <input
          className="w-40 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          value={email}
          onChange={changeEmail}
        />
      </label>{" "}
      <input
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        type="submit"
        value="Submit"
      />
    </form>
  )
}

export default function Signup() {
  const [showSuccess, setShowSuccess] = useState(false)

  return (
    <main>
      <nav className="flex justify-between bg-teal-600 p-2">
        <h1 className="text-2xl text-white">🎈 Weight Graph</h1>
      </nav>

      <div className="m-4 text-center">
        <p>
          This app uses <b>email links</b> for authentication. There is{" "}
          <b>no password</b> to remember!
          <br />
          <br />
          Just submit your email, check your inbox and click the link to sign in
          🥳
        </p>

        {!showSuccess ? (
          <EmailInput
            disabled={showSuccess}
            successHandler={() => setShowSuccess(true)}
          />
        ) : (
          <>
            <div className="my-4 p-4 bg-green-200 border-2 border-green-600 border-solid rounded-lg">
              Success! ✅ Check your email! 📧
            </div>
          </>
        )}
      </div>
    </main>
  )
}
